import React from "react";

// Real HPR logo image. Blue version for light backgrounds, white for dark.
export default function Logo({ variant = "dark", className = "" }) {
  const src = variant === "light" ? "/hpr-logo-white.png" : "/hpr-logo-blue.png";
  return (
    <img
      src={src}
      alt="HPR – High Performance Roofing"
      className={`h-8 sm:h-9 w-auto select-none ${className}`}
      draggable={false}
    />
  );
}
